import React from "react";
import Tile from "./Tile";

class Layer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    addTilesToRow(tiles, rowName) {
        let row = [];
        for (let i = 0; i < tiles.length; i++) {
            row.push(<Tile key={i} tile={tiles[i]} layer={this.props.layerNumber} row={rowName} index={i} clicker={this.props.clicker} graphics={this.props.graphics} />);
        }
        return row;
    } 

    render() {

        let classes = "layer " + this.props.layerNumber;

        let row1 = this.addTilesToRow(this.props.layerItems.row1, "row1");
        let row2 = this.addTilesToRow(this.props.layerItems.row2, "row2");
        let row3 = this.addTilesToRow(this.props.layerItems.row3, "row3");
        let row4 = this.addTilesToRow(this.props.layerItems.row4, "row4");
        let row5 = this.addTilesToRow(this.props.layerItems.row5, "row5");
        let row6 = this.addTilesToRow(this.props.layerItems.row6, "row6");
        let row7 = this.addTilesToRow(this.props.layerItems.row7, "row7");
        let row8 = this.addTilesToRow(this.props.layerItems.row8, "row8");

        return (
            <div className={classes}>
                <div className="row">{row1}</div>
                <div className="row">{row2}</div>
                <div className="row">{row3}</div>
                <div className="row">{row4}</div>
                <div className="row">{row5}</div>
                <div className="row">{row6}</div>
                <div className="row">{row7}</div>
                <div className="row">{row8}</div>
                
            </div>
        );
    }
}

export default Layer;